import { __decorate } from "tslib";
import Vue from 'vue';
import { Component, Watch } from 'vue-property-decorator';
import NameAndStatus from '@blade-sxp/task-management/components/name-status.vue';
import ValidTime from '@blade-sxp/task-management/components/valid-time1.vue';
import ButtonBox from '@blade-sxp/task-management/components/button-box.vue';
import DeviceDarwer from '@blade-sxp/task-management/components/deviceDarwer/index.vue';
import { postTask, updateTask, getTaskDetail } from '@blade-sxp/task-management/api/creat-task/index';
import { DeviceIdDataModule } from '@blade-sxp/task-management/store/deviceIdData';
import { isEmpty, cloneDeep } from 'lodash';
import { plotMap } from '@blade-sxp/task-management/components/deviceDarwer/plotConfig';
import { directionSet } from '@blade-sxp/task-management/utils/direction-set';
import TaskNote from '@blade-sxp/task-management/components/task-note.vue';
const Service = {
    postTask,
    updateTask,
    getTaskDetail,
};
let CrowdDensity = class CrowdDensity extends Vue {
    loading = false;
    name = '';
    status = 'ENABLE';
    isDetail = false;
    effectivePeriod = 'PERMANENT';
    effectiveDates = {
        start: '',
        end: '',
    };
    effectiveTimes = [{ start: '', end: '' }];
    dayOfWeeks = [];
    type = 'add';
    disableRight = false;
    id = '';
    taskType = '';
    isReady = false;
    isError = false;
    remark = '';
    get formData() {
        const { name, effectivePeriod, effectiveDates, effectiveTimes, dayOfWeeks, isReady } = this;
        return {
            name,
            effectivePeriod,
            effectiveDates,
            effectiveTimes,
            dayOfWeeks,
            isReady,
        };
    }
    async validForm() {
        if (this.isDetail) {
            return;
        }
        if (!this.isReady) {
            this.disableRight = true;
            return;
        }
        for (let i = 1; i <= 2; i++) {
            if (this.$refs['ruleForm' + i]) {
                let res = await this.$refs['ruleForm' + i].isValidate();
                if (!res) {
                    this.disableRight = true;
                    return;
                }
            }
        }
        this.disableRight = false;
    }
    init() {
        const { type, id, taskType } = this.$route.query;
        this.type = type;
        this.taskType = taskType;
        this.id = id;
        this.isDetail = type === 'detail';
        if (this.type === 'add') {
            this.loading = false;
        }
        else {
            if (this.isDetail) {
                this.disableRight = false;
            }
            this.getData();
        }
    }
    clickRightButton() {
        if (this.type === 'detail') {
            const url = this.$route.path;
            this.$router.push({ path: url, query: { type: 'update', taskType: this.taskType, id: this.id } });
            this.$route.meta.title = this.$route.meta.title.replace('look', 'edit');
        }
        else {
            this.submit();
        }
    }
    cancel() {
        if (this.type === 'detail') {
            this.$router.push('/tasklist');
        }
        else {
            this.$confirm(`${this.$t('cancelSubmitTip')}`, `${this.$t('tip')}`, {
                confirmButtonText: `${this.$t('confirm')}`,
                cancelButtonText: `${this.$t('cancel')}`,
                cancelButtonClass: 'cancel-roi-tip',
                confirmButtonClass: 'confirm-roi-tip',
                customClass: 'task-confirm',
            })
                .then(() => {
                this.$router.push('/tasklist');
            })
                .catch(() => { });
        }
    }
    submit() {
        let taskStatus = '';
        if (this.type === 'update') {
            if (this.isError && this.status === 'DISABLE') {
                taskStatus = 'DISABLE';
            }
            else if (this.isError && this.status === 'ENABLE') {
                taskStatus = 'ERROR';
            }
            else {
                taskStatus = this.status;
            }
        }
        else {
            taskStatus = this.status;
        }
        const effectiveTimes = [];
        if (this.effectivePeriod === 'CUSTOMIZE') {
            this.effectiveTimes.forEach((item) => {
                effectiveTimes.push({ start: item.effectiveTimes[0], end: item.effectiveTimes[1] });
            });
        }
        const params = {
            remark: this.remark,
            taskName: this.name,
            taskStatus: taskStatus,
            taskType: this.taskType,
            alarmConfig: {
                enable: true,
                thresholdConfigs: [
                    {
                        effectivePeriod: this.effectivePeriod,
                        dayOfWeeks: this.dayOfWeeks,
                        effectiveTimes: this.effectivePeriod === 'PERMANENT' ? [] : [...effectiveTimes],
                        effectiveDates: this.effectivePeriod === 'PERMANENT' ? [] : [this.effectiveDates],
                    },
                ],
            },
            deviceTaskConfigs: this.fromDataDeviceConfig(),
        };
        if (this.type === 'add' || this.type === 'copy') {
            Service.postTask(params).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
        else {
            Service.updateTask({ taskId: this.id, ...params }).then((res) => {
                this.$message.success(`${this.$t('common.success')}`);
                this.$router.push('/tasklist');
            });
        }
    }
    fromDataDeviceConfig() {
        let config = [];
        let device = DeviceIdDataModule.deviceIdRequestParams;
        let requestMap = new Map();
        requestMap = cloneDeep(device);
        const incidentType = plotMap.get(this.taskType).incidentType;
        if (!isEmpty(requestMap) && !isEmpty(incidentType)) {
            requestMap.forEach((item) => {
                const { zoneId, deviceId, titleList } = item;
                let persons = [];
                let rawRoi = {};
                let modelSelectionObj = {};
                let crosslineStatisticConfig = {};
                if (!isEmpty(titleList)) {
                    titleList.forEach((item) => {
                        if (item.type === 'BODY') {
                            item.data.forEach((item) => {
                                let pern = {
                                    x: item.vertices[0].y > item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                    y: item.vertices[0].y < item.vertices[1].y ? item.vertices[1].y : item.vertices[0].y,
                                };
                                persons.push(pern);
                            });
                        }
                        if (item.type === 'LINES') {
                            item.data.forEach((item) => {
                                crosslineStatisticConfig = {
                                    crossLine: item.vertices,
                                    directions: directionSet(item.direction),
                                    roiId: this.taskId(),
                                };
                            });
                        }
                        if (item.type === 'MODEL') {
                            modelSelectionObj.modelSelection = item.data;
                        }
                    });
                    rawRoi = { ...modelSelectionObj, ...crosslineStatisticConfig };
                }
                let data = {
                    crosslineStatisticConfig: rawRoi,
                    labelPersons: persons,
                    zoneId,
                    deviceId,
                    incidentType,
                    roiData: JSON.stringify(device.get(deviceId)),
                };
                config.push(data);
            });
        }
        return config;
    }
    taskId() {
        const num = Math.random() * 100000;
        return Math.round(num);
    }
    getData() {
        this.loading = true;
        Service.getTaskDetail(Number(this.id))
            .then(({ name, status, remark, alarmConfig: { thresholdConfigs }, deviceTaskConfigs }) => {
            this.name = name;
            this.remark = remark;
            if (status === 'ERROR') {
                this.isError = true;
                this.status = 'ENABLE';
            }
            else {
                this.status = status;
            }
            if (thresholdConfigs) {
                const { dayOfWeeks, effectiveDates, effectivePeriod, effectiveTimes } = thresholdConfigs[0];
                this.dayOfWeeks = dayOfWeeks;
                this.effectivePeriod = effectivePeriod;
                if (this.effectivePeriod !== 'PERMANENT') {
                    this.effectiveDates = effectiveDates[0];
                    this.effectiveTimes = effectiveTimes.map((item) => {
                        return { ...item, effectiveTimes: [item.start, item.end] };
                    });
                }
            }
            if (!isEmpty(deviceTaskConfigs)) {
                deviceTaskConfigs.forEach((item) => {
                    const roiData = item.roiData;
                    const modelType = item?.crosslineStatisticConfig?.modelSelection;
                    if (item.incidentType === 'INCIDENT_CROSS_LINE' && !isEmpty(roiData)) {
                        let analysis = JSON.parse(roiData);
                        if (modelType && analysis && analysis.titleList && analysis.titleList.length > 0) {
                            analysis.titleList.forEach((item) => {
                                if (item.type === 'MODEL') {
                                    item.data = modelType;
                                }
                            });
                        }
                        DeviceIdDataModule.deviceIdRequestParams.set(analysis.id, analysis);
                    }
                });
            }
        })
            .finally(() => {
            this.loading = false;
        });
    }
};
__decorate([
    Watch('formData', { deep: true, immediate: true })
], CrowdDensity.prototype, "validForm", null);
__decorate([
    Watch('$route', { immediate: true, deep: true })
], CrowdDensity.prototype, "init", null);
CrowdDensity = __decorate([
    Component({
        name: 'CrowdCrossline',
        components: {
            'name-and-status': NameAndStatus,
            'valid-time': ValidTime,
            'button-box': ButtonBox,
            'st-device-darwer': DeviceDarwer,
            'task-note': TaskNote,
        },
        i18n: {
            messages: {
                en: {
                    cancelSubmitTip: 'Data will not be saved and exited, are you sure to exit?',
                    tip: 'Title',
                    confirm: 'Confirm',
                    cancel: 'Cancel',
                },
                zh: {
                    cancelSubmitTip: '数据将不会保存并退出，确定退出吗？',
                    tip: '提示',
                    confirm: '确定',
                    cancel: '取消',
                },
            },
        },
    })
], CrowdDensity);
export default CrowdDensity;
